
            const data = {"name":"icomoon/angle-right","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" d=\"M21.199 16 9.774 4.128a1.115 1.115 0 0 1 0-1.567 1.09 1.09 0 0 1 1.55 0l12.529 12.653a1.115 1.115 0 0 1 0 1.567L11.324 29.434a1.088 1.088 0 0 1-1.55 0 1.115 1.115 0 0 1 0-1.567l11.425-11.868z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                